module.exports = __webpack_public_path__ + "img/reseller.11532dfa.png";